import type { Comparator } from '@domain/schemas/filters.schema';

/** `ex`/`nex` ("is not empty" / "is empty") test only for presence — no value input is needed. */
export const isExistenceComparator = (comparator: Comparator | string): boolean =>
  comparator === 'ex' || comparator === 'nex';
